import { ValidationError } from '../../field-validation';
import { FieldSchemaInterface } from '../../../../tokens-and-interfaces';
import { parsePhoneNumber } from './utils';
import { PhoneFieldsInterface } from '@vendasta/crm';
import { DEFAULT_COUNTRY_CODE } from './phone';

const e164FormatWarningValidatorFn =
  (isNotE164Compliant: boolean, initialParsedValue: PhoneFieldsInterface) => (control) => {
    const curPhoneValue = control.value;
    // show the warning if the phone number is not e164 compliant (and contains a phone value) and the user has not changed the phone number
    if (isNotE164Compliant && phoneValuesEqual(curPhoneValue, initialParsedValue)) {
      return {
        e164_format_warning: true,
      };
    }
    return null;
  };

function phoneValuesEqual(phone1, phone2) {
  return (
    phone1?.isoCountryCode === phone2?.isoCountryCode &&
    phone1?.nationalNumber === phone2?.nationalNumber &&
    phone1?.extension === phone2?.extension
  );
}

export function buildE164FormatValidator(schema: FieldSchemaInterface): { [key: string]: ValidationError } {
  const isNotE164Compliant = !schema.value?.e164Compliant && !!schema.value?.nationalNumber;

  const parsedPhoneNumber = parsePhoneNumber(schema.value?.nationalNumber || '');
  const parsedPhoneVals = {
    isoCountryCode: parsedPhoneNumber?.isoCountryCode || DEFAULT_COUNTRY_CODE,
    nationalNumber: parsedPhoneNumber?.nationalNumber || schema.value?.nationalNumber,
    extension: parsedPhoneNumber?.extension || '',
  } as PhoneFieldsInterface;

  return {
    e164_format_warning: {
      severity: 'WARNING',
      message: 'STANDARD_FIELD_RULES.E164_FORMAT.WARNING',
      validationFn: e164FormatWarningValidatorFn(isNotE164Compliant, parsedPhoneVals),
      asyncValidationFn: null,
    },
  };
}
